import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
import {
  COLUMNS,
  ROW_HEIGHT,
  TIMEBAND_LEVEL_NAME,
  OUTER_LEVEL_NAME,
  SECTOR_LEVEL_NAME,
  POSTCODE_LEVEL_NAME,
} from "../../consts/volumeOverlayTable";
import { View } from "../../components/View";

const useStyles = makeStyles({
  headerCell: {
    fontWeight: 700,
    backgroundColor: "#f9f9f9",
  },
  mouseOverRowCell: {
    backgroundColor: "#f9f9f9",
  },
  cell: {
    position: "fixed",
    display: "flex",
    alignItems: "center",
    paddingLeft: "10px",
    height: ROW_HEIGHT,
  },
});

export const RowsRendererComponent = ({
  onScreenRows,
  headerHeight,
  scrollOffset,
  mouseOverRow,
}) => {
  const styles = useStyles();

  const levelDetails = {
    [TIMEBAND_LEVEL_NAME]: {
      headerZIndex: 0,
      levelZIndex: -1,
      levelMargin: 0,
    },
    [OUTER_LEVEL_NAME]: {
      headerZIndex: -1,
      levelZIndex: -1,
      levelMargin: 20,
    },
    [SECTOR_LEVEL_NAME]: {
      headerZIndex: -1,
      levelZIndex: -1,
      levelMargin: 40,
    },
    [POSTCODE_LEVEL_NAME]: {
      headerZIndex: -1,
      levelZIndex: -1,
      levelMargin: 60,
    },
  };

  let firstCellOverride;
  const topVisibleRows =
    scrollOffset > -(ROW_HEIGHT * 0.7)
      ? onScreenRows.slice(1, 3)
      : onScreenRows.slice(2, 4);

  if (topVisibleRows.length === 2) {
    const [firstVisibleRow, secondVisibleRow] = topVisibleRows;
    if (
      firstVisibleRow.level !== TIMEBAND_LEVEL_NAME &&
      (topVisibleRows.every(({ isHeaderRow }) => !isHeaderRow) ||
        (!firstVisibleRow.isHeaderRow &&
          firstVisibleRow.level !== secondVisibleRow.level))
    )
      firstCellOverride = `${firstVisibleRow.timeband} / ${firstVisibleRow.level} `;
    else if (firstVisibleRow.level !== TIMEBAND_LEVEL_NAME)
      firstCellOverride = `${firstVisibleRow.timeband}`;
  }

  return onScreenRows.map((row, rowIndex) => {
    const { levelZIndex, headerZIndex, levelMargin } = levelDetails[row.level];
    const zIndex = row.isHeaderRow ? headerZIndex : levelZIndex;

    let rowTop = headerHeight + rowIndex * ROW_HEIGHT;
    if (!row.isHeaderRow || row.level !== TIMEBAND_LEVEL_NAME)
      rowTop += scrollOffset;

    const cellStyle = clsx(
      styles.cell,
      row.isHeaderRow && styles.headerCell,
      row === mouseOverRow && styles.mouseOverRowCell
    );

    return (
      <View key={row.id}>
        {COLUMNS.map(({ width, left, key }, columnIndex) => (
          <View
            key={`${row.id}-${columnIndex}`}
            className={cellStyle}
            style={{
              zIndex,
              top: `${rowTop}px`,
              left: `${levelMargin + left}px`,
              width,
            }}
          >
            {!rowIndex && !columnIndex && firstCellOverride
              ? firstCellOverride
              : row[key]}
          </View>
        ))}
      </View>
    );
  });
};
